import styled from 'styled-components';
import { DropdownItem, Dropdown } from '@minerva-analytics/pantheon';
import { LIGHT_GRAY } from 'root/theme';
import Menu from 'components/Menu';

const StyledNotificationsDropdown = styled(Dropdown)`
  @media (max-width: 414px) {
    max-height: 250px;
  }
  @media (max-width: 360px) {
    max-height: 260px;
  }
  @media (max-width: 320px) {
    max-height: 300px;
  }
`;

const NotificationsContainer = styled(Menu)`
  width: 90vw;
  max-width: 390px;
  top: 71px;
  right: 0;

  @media (max-width: 1200px) {
    right: 0;
    width: 85vw; 
  }

  @media (max-width: 768px) {
    top: 71px;
  }

  @media (max-width: 550px) {
    position: fixed;
    max-width: none;
    width: 100%;
    top: 90px;
    padding: 0;
  }
`;

const NotificationsItem = styled(DropdownItem)`
  margin: 0.5rem 0 0.5rem 0;
  border-bottom: 1px solid ${LIGHT_GRAY};
  align-items: flex-start;
  padding: 0 10px 0 10px;

  @media (max-width: 550px) {
    padding: 0 0px 0 10px;
  }
`;

export {
  NotificationsContainer,
  NotificationsItem,
  StyledNotificationsDropdown,
};
